import angular from 'angular';
import TopUps from './top.ups.component';
import { routing } from './top.ups.config';
export default angular.module('invision.customercare.customer.topups', []).config(routing).component('customerTopups', TopUps).name;